import { engineComponent, StringUtils } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { HtmlContainerElement } from "../Elements/HtmlContainerElement";
import { BetManager } from "../../Managers/BetManager";
import { AppContext } from "../../../Common/AppContext";
import { HtmlController } from "../HtmlController";
import { BaseActions } from "../../Channels/Common/Actions/BaseActions";
import { PlayList } from "../../Components/Sounds/PlayList";
import { DataManager } from "../../Managers/DataManager";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlLanuageContainerElement extends HtmlContainerElement {
    private _flags: Object = {};
    private _values: Object = {};

    constructor() {
        super();

        DataManager.LangContainer = this;
    }

    create(node: Element): void {
        super.create(node);

        this.addValues();
    }

    addValues(): void {
        let languages: Array<string> = AppContext.current.getAllowedLanguages();
        if (this.instance != null && languages != null) {
            for (let i: number = 0; i < languages.length; i++) {
                let flag: HTMLDivElement = <HTMLDivElement>document.createElement("div");
                flag.classList.add("flag");
                flag.classList.add(languages[i]);
                flag.style.display = "none";
                flag.setAttribute("Lng", languages[i]);
                flag.onclick = this.onValueClick.bind(this);
                let value: HTMLDivElement = <HTMLDivElement>document.createElement("div");
                value.classList.add("value");
                value.style.display = "none";
                value.setAttribute("Lng", languages[i]);
                //value.innerText = languages[i].toUpperCase();
                value.onclick = this.onValueClick.bind(this);

                if (
                    AppContext.current.getCurrentLanguage() != null &&
                    languages[i] == AppContext.current.getCurrentLanguage()
                ) {
                    flag.style.display = "block";
                    value.style.display = "block";
                }

                this._flags[languages[i]] = flag;
                this._values[languages[i]] = value;
                this.instance.appendChild(flag);
                this.instance.appendChild(value);
            }
        }
    }

    private onValueClick(e: any): void {
        if (e != null && e.currentTarget != null && e.currentTarget.hasAttribute("Lng")) {
            PlayList.play("SND_Click");
            let lang: string = e.currentTarget.getAttribute("Lng");

            if (this._flags != null) {
                for (let key in this._flags) {
                    this._flags[key].style.display = "none";
                }
            }

            if (this._values != null) {
                for (let key in this._values) {
                    this._values[key].style.display = "none";
                }
            }
            HtmlController.dispatchUiAction("");
            this.changeLanguage();
        }
    }

    changeLanguage(remote: boolean = false): void {
        if (remote) {
            PlayList.play("SND_Click");

            if (this._flags != null) {
                for (let key in this._flags) {
                    this._flags[key].style.display = "none";
                }
            }

            if (this._values != null) {
                for (let key in this._values) {
                    this._values[key].style.display = "none";
                }
            }
            HtmlController.dispatchUiAction("");
        }

        let actual: string = AppContext.current.getCurrentLanguage();
        let languages: Array<string> = AppContext.current.getAllowedLanguages();
        let next: string = "";

        if (actual != null && languages != null) {
            let index: number = 0;
            for (let i: number = 0; i < languages.length; i++) {
                if (languages[i] === actual) {
                    index = i;
                }
            }

            if (languages[index + 1] != null) {
                next = languages[index + 1];
            } else {
                next = languages[0];
            }
        }

        if (this._flags[next] != null) {
            this._flags[next].style.display = "block";
        }
        if (this._values[next] != null) {
            this._values[next].style.display = "block";
        }
        AppContext.current.setLanguage(next);
    }

    disable(): void {
        if (this.instance != null) {
            if (!this.instance.classList.contains("_disabled")) {
                this.instance.removeAttribute("style");
                this.instance.classList.add("_disabled");
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Custom/HtmlLanguageContainerElement.ts
 **/